// extracted by mini-css-extract-plugin
export default {"slider_wrapper":"ReasonsBlock_slider_wrapper__giHDe","content":"ReasonsBlock_content__bX85n","content_block":"ReasonsBlock_content_block__aUQya"};